import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import React from 'react';
import { MessageLocationDataType } from '../../../pages/NoticeMessageList';

interface props {
  MessageLocationData: MessageLocationDataType | null | undefined;
}

export const LocationMessageTable: React.FC<props> = (props) => {
  const { MessageLocationData } = props;
  return (
    <>
      <TableContainer h='100%' w='100%' overflowY='auto' overflowX='unset'>
        <Table variant='simple'>
          <Thead borderWidth='1px' position='sticky' top={0} zIndex='docked'>
            <Tr bg='gray.800'>
              <Th
                textAlign='center'
                borderWidth='1px'
                color='white'
                fontSize='16px'
              >
                英語メッセージ
              </Th>
              <Th
                textAlign='center'
                borderWidth='1px'
                color='white'
                fontSize='16px'
              >
                リンク
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td textAlign='center' w='50%'>
                {MessageLocationData?.message_en}
              </Td>
              <Td textAlign='center' w='50%'>
                {MessageLocationData?.link_url}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
